import React, { useState, useEffect } from 'react';
import {
  useStripe,
  useElements,
  PaymentElement,
  Elements
} from '@stripe/react-stripe-js';
import { loadStripe, PaymentIntentResult, SetupIntentResult } from '@stripe/stripe-js';
import axios from 'axios';
import { API_V1_PREFIX, isProd } from '../../utils/constants';
import { fireDiscountApplied, fireDiscountRemoved } from '../../utils/dataLayer';
import person from '../../assets/icons/person.png';
import ticks from '../../assets/icons/ticks.png';
import tracker from '../../assets/icons/tracker.png';
import food from '../../assets/icons/food.png';
import warningIcon from '../../assets/icons/warningIcon.png';
import checkmarkIcon from '../../assets/icons/checkmarkIcon.png';
import image1 from '../../assets/images/CoreVitalstest.png';
import image2 from '../../assets/images/CoreVitalstest2.png';
import image3 from '../../assets/images/CoreVitalstest3.png';
import image4 from '../../assets/images/CoreVitalstest4.jpg';
import image5 from '../../assets/images/CoreVitalstest5.png';
import mobileImage from '../../assets/images/mobileImage.png';
import './Subscription.scss';
import TextInput from '../../components/BaseComponents/TextInput';
import { toast } from 'react-toastify';
import manRunning from '../../assets/images/payment/sidebarImg.jpg';
import drnitin from '../../assets/images/payment/DrNitin.png';
import whiteTickIcon from '../../assets/images/payment/white-tick.svg';
import Footer from '../../components/common/Footer';
import TitleCopyTop from '../../components/common/TitleCopyTop';
import ErrorDisplay from '../../components/BaseComponents/ErrorDisplay';
import { categorizeError, ErrorInfo } from '../../utils/errorHandler';

const PaymentSidebar = () => {
  return (
    <div className='payment-sidebar'>
      <div className='payment-sidebar-content'>
        <div className='d-flex doctor-info' >
          <div>
            <img src={drnitin} width={58} height={58} alt='' />
          </div>
          <div>
            <h6>Dr. Nitin Shori</h6>
            <div>Chief Medical Officer</div>
          </div>
        </div>
      <div className='sidebar-copy' >Over</div>
        <div className='hightlight-text' >70% </div>
        <div className='sidebar-copy' >
        of members discover markers <span>they didn’t know about.</span>
        </div>
        <div className='included-in-membership' >
          <h5>Included in your membership</h5>
          <ul>
            <li>Twice-yearly blood tests (100+ biomarkers)</li>
            <li>1:1 clinician review</li>
            <li>1:1 nutritionist review</li>
            <li>Add previous blood results</li>
            <li>Unlimited support</li>
            <li>Personalised health plans</li>
          </ul>
        </div>
      </div>
      <img src={manRunning} alt='' className='payment-sidebar-image' />
    </div>
  )
}


const MapSection = () => {
  return (
    <div className='map-section'>
      <h3 className='title-2'>Find a testing location near you</h3>
      <div className='map-container'>
        <iframe
          src="https://www.google.com/maps/d/embed?mid=1manO6iBCLsWPFsKbGEeRMinYt51TfAI&amp;ehbc=2E312F&amp;noprof=1"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          loading='lazy'
          allowFullScreen
          referrerPolicy='no-referrer-when-downgrade'
          title='CoreVitals Testing Locations'
        />
      </div>
    </div>
  );
};

const MoneyBackGuarantee = () => {
  return (
    <div className='money-back-guarantee-banner'>
      <div className='guarantee-icon'>
        <div className='checkmark-icon'>
          <img src={checkmarkIcon} alt='Checkmark' />
        </div>
      </div>
      <div className='guarantee-text'>
        30-day money-back guarantee if you're not satisfied
      </div>
    </div>
  )
}
const HowItWorks = () => {
  const [activeStep, setActiveStep] = useState(0);

  const HowItWorksSteps = [
    {
      title: 'Activate',
      description: 'Pay now to start your annual membership and secure your spot.',
      image: image1
    },
    {
      title: 'Onboard',
      description: 'Complete a short health questionnaire, book your blood draw, and download our app.',
      image: image2
    },
    {
      title: 'Test',
      description: 'Receive your kit, complete your blood draw at a partner pharmacy, and send it to our lab.',
      image: image3
    },
    {
      title: 'Understand & Act',
      description: 'Unlock your results in-app, reviewed by doctors, with personalised nutritionist guidance and programs to optimise your health.',
      image: image4
    },
    {
      title: 'Go further',
      description: 'Choose optional add-ons, such as full-body scans, polygenic risk scoring, or specialist blood panels, for a more comprehensive view.',
      image: image5
    }
  ];
  return (
    <div className='Second-card-style'>
      <h3 className='how-it-works-title'>How it works</h3>
      <div className='how-it-works-container'>
        <div className='left-container'>
          
          {HowItWorksSteps.map((step, index) => (
            <div key={index} className={`${activeStep === index ? 'active' : ''}`} >
              {activeStep === index && <div className='mobile-image-who-it-works' ><img src={step.image} alt={step.title} /></div>}
              <div className='step-item'>
                <div className='d-flex align-items-center gap-10' onClick={() => setActiveStep(index)} >
                  <div className='step-number'>{index + 1}.</div>
                  <div className='step-title'>{step.title}</div>
                </div>
                {activeStep === index && <div className='step-content'>
                  <div className='step-description'>{step.description}</div>
                </div>}
              </div>
            </div>
          ))}
          
        </div>
        <div className='right-container'>
          {activeStep !== null && (
            <div className='desktop-image-how-it-works'>
              <img src={HowItWorksSteps[activeStep].image} alt={HowItWorksSteps[activeStep].title} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const WarningNote = () => {
  return (
    <div className='d-flex justify-content-center' >
      <div className='expiry-warning-banner'>
        <div className='warning-icon'>
          <img src={warningIcon} alt='Warning' />
        </div>
        <div className='warning-text'>
          Your membership space will expire in 7 days - secure your place now.
        </div>
      </div>
    </div>
  );
};

const ListPoints = () => {
  return (
    <ul className='tick-list'>
      <li>
        <div>
          <img src={person} alt='' />
        </div>
        Two doctor-reviewed, lab-based blood tests per year: a comprehensive panel plus a follow-up to track progress.
      </li>
      <li>
        <div>
          <img src={food} alt='' />
        </div>
        1:1 guidance from nutritionists and structured risk- and condition-based programs tailored to your health.
      </li>
      <li>
        <div>
          <img src={ticks} alt='' />
        </div>
        Personalised insights covering 150+ health conditions.
      </li>
      <li>
        <div>
          <img src={tracker} alt='' />
        </div>
        Track progress, reduce health risks, and extend your health span with actionable insights.
      </li>
    </ul>
  );
};
const CheckoutForm = ({
  onComplete,
  intentMode
}: {
  onComplete: (memberDetails: any) => void;
  intentMode: 'payment' | 'setup';
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState<string | null>(null);
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');
  const [processing, setProcessing] = useState(false);
  const [agreeToTerms, setAgreeToTerms] = useState(true);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setProcessing(true);
    try {
      if (intentMode === 'setup') {
        const result = (await stripe.confirmSetup({
          elements,
          redirect: 'if_required',
          confirmParams: {
            return_url: `${window.location.origin}/complete-profile?token=${token}`
          }
        })) as SetupIntentResult;

        if (result.error) {
          setError(result.error.message || 'An error occurred');
        } else if (result.setupIntent) {
          if (result.setupIntent.status === 'succeeded') {
            onComplete(null);
          } else {
            setError(`Card setup ${result.setupIntent.status}. Please try again.`);
          }
        }
      } else {
        const result = (await stripe.confirmPayment({
          elements,
          redirect: 'if_required',
          confirmParams: {
            return_url: `${window.location.origin}/complete-profile?token=${token}`
          }
        })) as PaymentIntentResult;

        if (result.error) {
          setError(result.error.message || 'An error occurred');
        } else if (result.paymentIntent) {
          if (result.paymentIntent.status === 'succeeded') {
            onComplete(null);
          } else {
            setError(`Payment ${result.paymentIntent.status}. Please try again.`);
          }
        }
      }
    } catch (error) {
      console.error('Error processing payment:', error);
      if (axios.isAxiosError(error) && error.response && error.response.data) {
        const errorData = error.response.data as { message?: string };
        setError(
          errorData.message ||
            'Failed to process payment. Please try again.'
        );
      } else {
        setError('Failed to process payment. Please try again.');
      }
    } finally {
      setProcessing(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <label className='checkbox-container'>
        <input
          type='checkbox'
          checked={agreeToTerms}
          onChange={(e) => setAgreeToTerms(e.target.checked)}
        />
        I agree to
        <a
          href='https://www.corevitals.me/privacy-policy'
          target='_blank'
          rel='noreferrer'
        >
          Privacy Policy
        </a>{' '}
        and
        <a
          href='https://www.corevitals.me/member-terms-and-conditions'
          target='_blank'
          rel='noreferrer'
        >
          Terms and Conditions
        </a>
      </label>

      <button
        className='button payNowBtn'
        disabled={!stripe || processing || !agreeToTerms}
      >
        {processing ? 'Processing...' : 'Pay now'}
      </button>
      {error && <div className='error-message'>{error}</div>}
    </form>
  );
};

const Subscription: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState<number | null>(null);
  const [paymentPeriod, setPaymentPeriod] = useState<'monthly' | 'yearly'>('yearly');
  const [discountCode, setDiscountCode] = useState<string>('');
  const [discountApplied, setDiscountApplied] = useState<boolean>(false);
  const [token, setToken] = useState<string | null>(null);
  const [clientSecret, setClientSecret] = useState<string | null>(null);
  const [intentMode, setIntentMode] = useState<'payment' | 'setup'>('payment');
  const [step, setStep] = useState(1);
  const [memberDetails, setMemberDetails] = useState<any>({});
  const [hasActiveSubscription, setHasActiveSubscription] = useState<boolean | null>(null);
  const [errorInfo, setErrorInfo] = useState<ErrorInfo | null>(null);
  const urlParams = new URLSearchParams(window.location.search);
  const tokenParam = urlParams.get('token');
  
  useEffect(() => {
    const script1 = document.createElement('script');
    script1.src = 'https://static.klaviyo.com/onsite/js/XHFa9D/klaviyo.js?company_id=XHFa9D';
    script1.async = true;
    script1.type = 'text/javascript';
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.type = 'text/javascript';
    script2.textContent = `
      !function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();
    `;
    document.head.appendChild(script2);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);

  useEffect(() => {
    if (!tokenParam) return;

    const baseURL = isProd
      ? process.env.REACT_APP_API_BASE_URL_PROD
      : process.env.REACT_APP_API_BASE_URL_DEV;

    const checkActiveSubscription = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/${API_V1_PREFIX}subscriptions/check-active`,
          {
            headers: {
              Authorization: `Bearer ${tokenParam}`
            }
          }
        );
        setHasActiveSubscription(response?.data?.response);
        setErrorInfo(null);
      } catch (error) {
        console.error('Error checking subscription status:', error);
        const categorizedError = categorizeError(error);
        if (
          categorizedError.type === 'access_restricted' ||
          categorizedError.type === 'network_error' ||
          categorizedError.type === 'session_expired'
        ) {
          setErrorInfo(categorizedError);
        } else {
          setErrorInfo(null);
          setHasActiveSubscription(false);
        }
      }
    };

    checkActiveSubscription();
  }, [tokenParam]);

  useEffect(() => {
    if (!tokenParam) {
      window.location.href = `${window.location.origin}/complete-profile?token=${tokenParam}`;
    }
    setToken(tokenParam);
  }, [tokenParam]);

  useEffect(() => {
    const signupResponse = localStorage.getItem('signupResponse');
    if (signupResponse && tokenParam) {
      try {
        const signupData = JSON.parse(signupResponse);
        const amount = signupData.amount;
        // If discount makes total free, backend may return a SetupIntent client_secret instead of PaymentIntent.
        if ((amount === 0 || amount === '0') && !signupData.client_secret && !signupData.setup_intent_client_secret) {
          localStorage.removeItem('signupResponse');
          window.location.href = `/complete-onboarding?token=${tokenParam}`;
          return;
        }

        if ((signupData.client_secret || signupData.setup_intent_client_secret) && amount != null) {
          window.dataLayer.push({
            event: 'signup',
            amount,
            product: 'CoreVitals',
            interval: 'year',
            member_details: signupData
          });
          if (signupData.client_secret) {
            setClientSecret(signupData.client_secret);
            setIntentMode('payment');
          } else if (signupData.setup_intent_client_secret) {
            setClientSecret(signupData.setup_intent_client_secret);
            setIntentMode('setup');
          }
          if (amount !== undefined && amount !== null) {
            setAmount(amount);
            setPaymentPeriod(amount > 100 ? 'yearly' : 'monthly');
          }
          setStep(2);
          
          if (signupData.promocode) {
            setDiscountCode(signupData.promocode);
          }
          
          localStorage.removeItem('signupResponse');
        }
      } catch (error) {
        console.error('Error parsing signup response:', error);
        localStorage.removeItem('signupResponse');
      }
    }
  }, [tokenParam]);

  useEffect(() => {
    if (!tokenParam) return;
    
    const fetchMemberDetails = async () => {
      try {
        const baseURL = isProd
          ? process.env.REACT_APP_API_BASE_URL_PROD
          : process.env.REACT_APP_API_BASE_URL_DEV;
        const response = await axios.get(
          `${baseURL}/${API_V1_PREFIX}members?loading_strategy=with_subscription`,
          {
            headers: {
              Authorization: `Bearer ${tokenParam}`
            }
          }
        );
        window.dataLayer.push({
          event: 'subscription_page_view',
          member_details: response.data
        });
        setMemberDetails(response.data);
        setErrorInfo(null);
      } catch (error) {
        console.error('Error fetching member details:', error);
        const categorizedError = categorizeError(error);
        if (
          categorizedError.type === 'access_restricted' ||
          categorizedError.type === 'network_error' ||
          categorizedError.type === 'session_expired'
        ) {
          setErrorInfo(categorizedError);
        } else {
          setErrorInfo(null);
        }
      }
    };
    
    fetchMemberDetails();
  }, [tokenParam, step]);

  const stripePromise = React.useMemo(
    () => loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ''),
    []
  );

  const handleApplyDiscount = () => {
    if (discountCode.trim()) {
      setDiscountApplied(true);
      localStorage.setItem('appliedPromocode', discountCode.trim());
      fireDiscountApplied(discountCode.trim());
      toast.success('Discount code saved! If valid, discount will be applied on the next step.');
    } else {
      toast.error('Please enter a discount code');
    }
  };

  const handleRemoveDiscount = () => {
    const removedCode = discountCode.trim();
    setDiscountApplied(false);
    localStorage.removeItem('appliedPromocode');
    setDiscountCode('');
    fireDiscountRemoved(removedCode);
    toast.success('Discount code removed');
  };

  const fetchClientSecret = async () => {
    if (!tokenParam) {
      return;
    }
    try {
      setIsLoading(true);
      const baseURL = isProd
        ? process.env.REACT_APP_API_BASE_URL_PROD
        : process.env.REACT_APP_API_BASE_URL_DEV;

      let promocodeToSend: string | null = null;
      if (discountApplied && discountCode && discountCode.trim()) {
        promocodeToSend = discountCode.trim();
      }

      const payload: any = {};
      if (promocodeToSend) {
        payload.promocode = promocodeToSend;
      }

      const response = await axios.post(
        `${baseURL}/${API_V1_PREFIX}subscriptions`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${tokenParam}`
          }
        }
      );

      setStep(2);
      if (response.data.amount !== undefined && response.data.amount !== null) {
        setAmount(response.data.amount);
        setPaymentPeriod(response.data.amount > 100 ? 'yearly' : 'monthly');
      }
      if (response.data.client_secret) {
        setClientSecret(response.data.client_secret);
        setIntentMode('payment');
      } else if (response.data.setup_intent_client_secret) {
        setClientSecret(response.data.setup_intent_client_secret);
        setIntentMode('setup');
      } else {
        setClientSecret(null);
      }
      setErrorInfo(null);
    } catch (error) {
      console.error('Error creating subscription:', error);
      const categorizedError = categorizeError(error);
      if (
        categorizedError.type === 'access_restricted' ||
        categorizedError.type === 'network_error' ||
        categorizedError.type === 'session_expired'
      ) {
        setErrorInfo(categorizedError);
      } else {
        setErrorInfo(null);
        if ((error as any)?.response?.data?.detail) {
          toast.error((error as any)?.response?.data?.detail);
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const baseURL = isProd
      ? process.env.REACT_APP_API_BASE_URL_PROD
      : process.env.REACT_APP_API_BASE_URL_DEV;

    if (!baseURL) {
      window.location.href = `${window.location.origin}/complete-profile?token=${tokenParam}`;
    }
  }, [tokenParam]);

  const options = clientSecret
    ? {
        clientSecret,
        appearance: {
          theme: 'stripe' as const
        }
      }
    : undefined;

  const LetsGetStarted = () => {
    return (<div>
      <div className='no-card-container'>
        <h3 className='title-2'>Let's get started</h3>
        <p>Take control of your health - it starts here.</p>
      </div>
      <div className='d-flex justify-content-center' >
      <button
        className='button payNowBtn'
        onClick={fetchClientSecret}
      >
        Pay now
      </button>
      </div >
      <div className='question-link'>
        <a href='mailto:members@corevitals.me'>Questions? We're here to help.</a>
      </div>
      <MapSection />
    </div>
    )
  }

  if (step === 3) {
    return (
      <>
      <TitleCopyTop
        title={<><span>Welcome</span> to CoreVitals!</>}
        copy={<>Thanks for joining us, <span>{memberDetails.first_name} {memberDetails.last_name}</span>!</>}
      />
      <div className='stepperWrapper' >
        <div className='stepItem fade' >
          <div className='stepperStatus ' >
            <span><img src={whiteTickIcon} alt='Complete' /> Complete</span>
          </div>
          <div className='stepName' >Confirmed member</div>
          <div className='stepDescription' >Your subscription is confirmed.</div>
        </div>
        <div className='stepItem' >
          <div className='stepperStatus' >
            <span><img src={whiteTickIcon} alt='Complete' /> Complete</span>
          </div>
          <div className='stepName' >Test kit shipped</div>
          <div className='stepDescription' >Your test kit is on the way.</div>
        </div>
        <div className='stepItem last-step' >
          <div className='stepperStatus' >
            <span>3</span>
          </div>
          <div className='stepName' >Onboarding</div>
          <div className='stepDescription' >Start the onboarding process.</div>
        </div>
      </div>
      <div className='small-container' >
        <button onClick={() => (window.location.href = `/complete-profile?token=${token}`)}
        className='continue-btn' >CONTINUE</button>
        <div className='help-section'>
          <h3>Need help?</h3>
          <p>
            If you have any questions, just reply to your confirmation email
            or reach out at <br />{' '}
            <a href='mailto:members@corevitals.me'>members@corevitals.me</a>
          </p>
        </div>
      </div>
      <Footer />
      </>
    );
  }

  if (errorInfo) {
    return (
      <>
        <div className='main-wrapper' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 'calc(100vh - 100px)', width: '100%' }}>
          <div style={{ padding: '40px 20px', width: '100%', display: 'flex', justifyContent: 'center' }}>
            <ErrorDisplay errorInfo={errorInfo} />
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (<>
  <div className='main-wrapper'>
      <div className='subscription-container'>
        {hasActiveSubscription ? (
          <div className='success-container'>
            <div className='subscription-header'>
              <h3>
                Hello, {memberDetails.first_name} {memberDetails.last_name}
              </h3>
              <h3>You are already subscribed to CoreVitals!</h3>
              <p>
                Thank you for being a member. You already have an active subscription.
              </p>
            </div>
            <div className='card-style white-card'>
              <h3 className='title-2'>Need assistance?</h3>
              <p>
                If you need any help or have questions about your subscription, 
                please contact us at{' '}
                <a href='mailto:members@corevitals.me'>members@corevitals.me</a>
              </p>
            </div>
            <div className='card-style white-card'>
              <h3 className='title-2'>What's next?</h3>
              <p>
                You can continue with your health journey by completing your profile 
                and booking your next blood test.
              </p>
              <button
                onClick={() =>
                  (window.location.href = `/complete-profile?token=${token}`)
                }
                className='button button2'
              >
                Continue to Profile
              </button>
            </div>
          </div>
        ) : isLoading ? (
          <div className='card-style loading-message'>
            Processing your subscription...
          </div>
        ) : (
          <>
            {step === 1 && (
              <div className='success-container'>
                <div className='subscription-header'>
                  <h3>
                    Hello, {memberDetails.first_name} {memberDetails.last_name}
                  </h3>
                  <h3>Your proactive health journey starts today.</h3>
                  <p>
                  Stay ahead of risks and symptoms with doctor-reviewed biomarker testing, personalised recommendations, and structured programs to support your health.
                  </p>
                </div>
                <WarningNote />
                <div className='text-center'>
                  <img src={mobileImage} alt='' className='mobile-image' />
                </div>
                <MoneyBackGuarantee />
                <div className=''>
                  <div className='card-style'>
                    <h3 className='title-2 gradient-heading'>
                      What's included in your annual membership?
                    </h3>
                     <ListPoints />
                  </div>
                </div>
                <HowItWorks />
                <div className='discount-code-section'>
                  <h4 className='discount-title'>Discount code</h4>
                  <div className='discount-input-container'>
                     <TextInput
                       name='discountCode'
                       placeholder='Enter discount code here'
                       type='text'
                       style={{ width: '266px' }}
                       onChange={(e) => {
                         setDiscountCode(e.target.value);
                       }}
                       value={discountCode}
                       isDisabled={discountApplied}
                     />
                    <button 
                      className='apply-discount-btn'
                      onClick={discountApplied ? handleRemoveDiscount : handleApplyDiscount}
                    >
                      <span>{discountApplied ? 'REMOVE' : 'APPLY'}</span>
                      &nbsp;
                      <span>DISCOUNT</span>
                    </button>
                  </div>
                </div>
                <LetsGetStarted />
              </div>
            )}
            {step === 2 &&
            process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY &&
            clientSecret ? (
              <div className='main-wrapper'>
                <TitleCopyTop
                  title={<><span>Secure</span> your membership.</>}
                  copy={(() => {
                    if (amount !== null && amount !== undefined) {
                      if (paymentPeriod === 'yearly') {
                        const monthlyAmount = amount / 12;
                        return `£${Math.round(monthlyAmount)}/month - billed annually at £${Math.round(amount).toLocaleString()}.`;
                      } else {
                        return `£${Math.round(amount).toLocaleString()}/month`;
                      }
                    }
                    return '£40/month - billed annually at £475.';
                  })()}
                />
                <div className='payment-row' >
                  <div className='payment-form' >
                    <div className='card-style white-card' >
                      <h3 className='box-title'>Contact Information</h3>
                      <Elements key={clientSecret} stripe={stripePromise} options={options}>
                        <CheckoutForm
                          onComplete={() => {
                            setStep(3);
                            window.dataLayer.push({
                              event: 'purchase',
                              member_details: memberDetails
                            });
                          }}
                          intentMode={intentMode}
                        />
                      </Elements>  
                    </div>
                  </div>
                  <PaymentSidebar />
                </div>  
                  
                
              </div>
            ) : step === 2 ? (
              <div className='loading-message'>Initializing payment...</div>
            ) : null}
          </>
        )}
      </div>
    </div>
    <Footer />
  </>  
  );
};

export default Subscription;
